import { useResolvedUser } from '@tcc/shared-data-lib';
import { useMemo } from 'react';
import { useUserLoggedInConfigs } from '../utils/sharedData';
import { isDealerImpersonatingFarmer, isImpersonating, isImpersonationNotAvailable, isProxyingItself } from '../utils/isImpersonating';
import { ImpersonationMode } from '../types/impersonationModes';
import { User } from '../types/user';

export type UseImpersonationMode = {
  isLoading: boolean;
  impersonationModes: ImpersonationMode[];
  user?: User;
  impersonatedUser?: User;
  isImpersonating: boolean;
};

export const useImpersonationMode = (): UseImpersonationMode => {
  const {
    user,
    impersonatedUser,
    isLoading: isResolvedUserLoading,
  } = useResolvedUser(useUserLoggedInConfigs);

  const impersonationModes = useMemo(() => {
    const impersonationModesSet: Set<ImpersonationMode> = new Set();
    if (!isResolvedUserLoading && user) {
      if (isImpersonationNotAvailable(user.details)) impersonationModesSet.add(ImpersonationMode.IMPERSONATION_NOT_AVAILABLE);
      if (isImpersonating(user.details)) impersonationModesSet.add(ImpersonationMode.IMPERSONATION_ACTIVE);
      if (isProxyingItself(user.details)) impersonationModesSet.add(ImpersonationMode.PROXYING_ITSELF).add(ImpersonationMode.IMPERSONATION_ACTIVE);
      if (isDealerImpersonatingFarmer(user, impersonatedUser)) impersonationModesSet.add(ImpersonationMode.DEALER_PROXYING_FARMER);
    }

    return Array.from(impersonationModesSet);
  }, [
    isResolvedUserLoading,
    user,
    impersonatedUser
  ]);

  const inpersonationActive = impersonationModes.includes(ImpersonationMode.IMPERSONATION_ACTIVE) &&
    !impersonationModes.includes(ImpersonationMode.PROXYING_ITSELF);

  return {
    isLoading: isResolvedUserLoading,
    impersonationModes,
    user,
    impersonatedUser: impersonatedUser || user,
    isImpersonating: inpersonationActive
  };
};
